import {Routes} from "react-router";
import {Route} from "react-router-dom";
import React from "react";
import {Publishing} from "./Publishing";

export const PublishingRouter = () => {

  return <Routes>
    <Route path={'/'} element={<Publishing/>}/>
  </Routes>
}